import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ADMIN_API, RESOURCES_API, USER_API, extractScholarship } from '../../functions'
import axios from 'axios'
import { PieChart } from 'react-minimal-pie-chart';
import { PreviousTestsCard, TestAnalysisCard, TestResult, SideBarGPT } from '../../Components'
import Cookies from 'js-cookie';
import { useRef } from 'react'
import lottie from 'lottie-web'
import Swal from 'sweetalert2';



const TestAnalysis = ({ testAnalysis, user, fathername, classs, city, setShowAnalysis }) => {

    const [TestAttempted, setTestAttempted] = useState({
        name: 'test',
        date: '--/--/----',
        responses: [],
        actualAnswers: []
    });

    const [showAnalysis1, setShowAnalysis1] = useState(false);

    let score = 0;
    let correct = 0, incorrect = 0, unattempted = 0;

    const calculateDetails = async () => {

        const testDetails = await axios.get(`${ADMIN_API}/getAllTest/${testAnalysis.testId}`);
        let testValue = {
            name: testDetails.data.foundTest.TestInfo.TestName,
            date: testAnalysis.date,
            responses: testAnalysis.responses,
            actualAnswers: testDetails.data.foundTest.QuestionSet,
            analysis: testDetails.data.foundTest.TestInfo.showAnalysis
        }

        // console.log(testValue)
        setTestAttempted(testValue);
    }

    useEffect(() => {
        calculateDetails();
    }, [testAnalysis])




    const getYourAnswer = (index) => {
        let ans = TestAttempted.responses[index].Response;
        if (ans.status === 0) {
            return (
                <div className='text-center text-gray-500 font-semibold'>Unattempted</div>
            )
        }
        if (TestAttempted.actualAnswers[index].QuestionType === "Integer Type Answer") {
            return (
                <div className='text-center font-semibold'>{ans.IntegerAnswer}</div>
            )
        }
        else if (TestAttempted.actualAnswers[index].QuestionType === "Single Correct Option") {
            return (
                <div className='text-center font-semibold'>{TestAttempted.actualAnswers[index].Options[ans.Options[0] - 1].Option}</div>
            )
        }
        else if (TestAttempted.actualAnswers[index].QuestionType === "Multiple Correct Option") {
            return (
                <ul className='text-center font-semibold'>
                    {ans.Options.map((option) => (
                        <li>{TestAttempted.actualAnswers[index].Options[option - 1].Option}</li>
                    ))}
                </ul>
            )
        }
    }

    const getCorrectAnswer = (index) => {
        let ans = TestAttempted.actualAnswers[index];


        if (ans.QuestionType === "Integer Type Answer") {
            return (
                <div className='text-center font-semibold'>{ans.IntegerAnswer}</div>
            )
        }
        else if (ans.QuestionType === "Single Correct Option") {
            return (
                <div>
                    {ans.Options.map((option, index) => {
                        if (option.IsAnswer) {
                            return (
                                <div className='text-center font-semibold'>{option.Option}</div>
                            )
                        }
                    })
                    }
                </div>
            )
        }
        else if (ans.QuestionType === "Multiple Correct Option") {
            return (
                <ul className='text-center font-semibold'>
                    <div>
                        {ans.Options.map((option, index) => {
                            if (option.IsAnswer) {
                                return (
                                    <div className='text-center font-semibold'>{option.Option}</div>
                                )
                            }
                        })
                        }
                    </div>
                </ul>
            )
        }
    }

    let questionAnalysis = [
    ];

    const calculateScore = () => {
        TestAttempted.responses.map((response, index) => {
            if (response.Response.status === 0) {
                unattempted++;
                questionAnalysis.push({
                    status: 0,
                })
                return;
            }
            if (TestAttempted.actualAnswers[index].QuestionType === "Integer Type Answer") {
                if (parseInt(response.Response.IntegerAnswer) === parseInt(TestAttempted.actualAnswers[index].IntegerAnswer)) {
                    score += 4;
                    correct++;
                    questionAnalysis.push({
                        status: 4,
                    })
                }
                else {
                    incorrect++;
                    questionAnalysis.push({
                        status: 10,
                    })
                }
            }
            else if (TestAttempted.actualAnswers[index].QuestionType === "Single Correct Option") {
                let ansIndex = 0;
                const temp = TestAttempted.actualAnswers[index].Options.map((option, index) => {
                    if (option.IsAnswer) {
                        ansIndex = index + 1;
                    }
                }
                )
                if (response.Response.Options[0] === ansIndex) {
                    // console.log("hi");
                    score += 4;
                    correct++;
                    questionAnalysis.push({
                        status: 4,
                    })
                }
                else {
                    // console.log("hello")
                    incorrect++;
                    score--;
                    questionAnalysis.push({
                        status: -1,
                    })
                }
            }
            else if (TestAttempted.actualAnswers[index].QuestionType === "Multiple Correct Option") {
                // check if the response is correct or not
                let resStr = "";
                let responseArray = response.Response.Options.map((option) => {
                    resStr += option;
                }
                )
                let actStr = "";
                let actualArray = TestAttempted.actualAnswers[index].Options.map((option, index) => {
                    if (option.IsAnswer) {
                        actStr += (index + 1);
                    }
                }
                )

                console.log(resStr, actStr);

                // sort both strings
                resStr = resStr.split('').sort().join('');
                actStr = actStr.split('').sort().join('');

                console.log(resStr, actStr);

                if (resStr === actStr) {
                    score += 4;
                    correct++;
                    questionAnalysis.push({
                        status: 4,
                    })
                }
                else {
                    incorrect++;
                    score--;
                    questionAnalysis.push({
                        status: -1,
                    })
                }
            }
        })

        return score;
    }


    return (
        <div className='w-[100%]'>
            <div className='w-[100%] mt-[4vh] mx-[5vw]'>
                <button
                    onClick={() => {
                        setShowAnalysis1(false);
                        setShowAnalysis(false);
                    }}
                    className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4'

                >Go Back</button>
                <h1 className='my-[6vh] font-semibold'>Performance Analysis</h1>
            </div>
            <TestResult
                name={user}
                fatherName={fathername}
                score={calculateScore() + "/" + TestAttempted.actualAnswers.length * 4}
                date={TestAttempted.date}
                scholarship={extractScholarship(score, TestAttempted)}
                classs={classs}
                city={city}
                testName={TestAttempted.name}
            />


            <div className='flex justify-center text-center'>
                {TestAttempted.analysis ? (
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            setShowAnalysis1(!showAnalysis1)
                        }}
                        class=" hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 m-3 max-w-[20rem] border border-blue-500 hover:border-transparent rounded">
                        {showAnalysis1 ? "Hide Analysis" : "Show Analysis"}
                    </button>
                ) : (
                    <div>
                        <h1 className='text-center text-3xl bold m-4'>Test Score Analysis</h1>
                        <p className='text-center'>Question-wise Analysis is currently unavailable</p>
                    </div>)
                }
            </div>


            <div>
                <h1 className='text-center text-3xl bold m-4'>Test Score Analysis</h1>
                <div className='flex flex-wrap justify-center align-middle'>
                    {TestAttempted.actualAnswers.map((question, index) => {
                        return (
                            showAnalysis1 ? (
                                <TestAnalysisCard
                                    index={index}
                                    Question={question.Question}
                                    QuestionImg={`${RESOURCES_API}${question.QuestionImg}`}
                                    QuestionType={question.QuestionType}
                                    YourAns={getYourAnswer(index)}
                                    CorrectAns={getCorrectAnswer(index)}
                                    status={questionAnalysis[index].status}
                                />
                            ) : (null)
                        )
                    }
                    )}
                </div>
            </div>

            <div className='flex flex-col justify-center align-middle text-center border-2 border-gray-300 rounded-lg p-2'>
                <p className='text-2xl font-extrabold '> Pie Chart Analysis </p>
                <PieChart
                    data={[
                        { title: 'Correct', value: correct, color: '#35CE8D' },
                        { title: 'Incorrect', value: incorrect, color: '#CC2936' },
                        { title: 'Unattempted', value: unattempted, color: '#D8DCFF' },
                    ]}
                    label={({ dataEntry }) => {
                        return (dataEntry.value > 0 ? `${dataEntry.title} : ${dataEntry.value}` : null)
                    }
                    }
                    className='max-w-[350px] m-auto p-6 text-[5px] text-white border-2 border-gray-300 rounded-lg'
                    animate={true}
                />
                <ul className='flex justify-center align-middle flex-col'>
                    <li className='flex justify-center align-middle'>
                        <div className='w-[20px] h-[20px] bg-[#35CE8D] rounded-full m-2'></div>
                        <p className='text-lg font-semibold'>Correct - {correct}</p>
                    </li>
                    <li className='flex justify-center align-middle'>
                        <div className='w-[20px] h-[20px] bg-[#CC2936] rounded-full m-2'></div>
                        <p className='text-lg font-semibold'>Incorrect - {incorrect}</p>
                    </li>
                    <li className='flex justify-center align-middle'>
                        <div className='w-[20px] h-[20px] bg-[#D8DCFF] rounded-full m-2'></div>
                        <p className='text-lg font-semibold'>Unattempted - {unattempted}</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

const PreviousResults = ({ testDetails, setTestAnalysis, setShowAnalysis, showAnalysis }) => {

    if (testDetails.length === 0) {
        return (
            <div className='w-[100%] mt-[4vh] mx-[5vw]'>
                <h1 className='my-[6vh]  font-semibold'>My Test Records</h1>
                <div className='flex justify-center align-bottom flex-wrap '>
                    <img src={require(`../../assets/NoDataFound.webp`)} className=" max-w-[max(50vw,400px)]" alt="No data Available" />
                </div>
            </div>
        )
    }
    // console.log(testDetails);
    return (
        <div className='w-[100%] mt-[4vh] mx-[2vw]'>
            <h1 className='my-[6vh]  font-semibold'>My Test Records</h1>
            <div className='flex align-middle flex-wrap'>
                {testDetails.map((test) => (
                    <PreviousTestsCard test={test} callback={setTestAnalysis} stateManage={setShowAnalysis} state={showAnalysis} date={test.date} />
                ))}
            </div>
        </div>
    )
}
const MyTestAttempts = () => {

    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [fathername, setFathername] = useState();
    const [city, setCity] = useState();
    const [classs, setClasss] = useState();
    const [showAnalysis, setShowAnalysis] = useState(false);
    const [testAnalysis, setTestAnalysis] = useState();
    const [ifLoading, setIfLoading] = useState(true);

    let UserID = localStorage.getItem("user");
    UserID = JSON.parse(UserID);
    const initialTest = [
        {
            id: 1,
            test: '-- -- ---',
            score: "--/--",
            date: "DD/MM/YYYY",
        }
    ]
    const [testDetails, setTestDetails] = useState(initialTest);

    const setLoadedData = async () => {
        UserID = localStorage.getItem("user")
        UserID = JSON.parse(UserID);
        if (UserID === null) {
            navigate("/");
        }
        else {
            let res = await axios.get(`${USER_API}/getData/${UserID}`);
            const data = res.data;
            if (data.ifAdmin) {
                navigate("/Admin")
            }
            // console.log(data);
            setUser(data.Name);
            setFathername(data.FatherName);
            setCity(data.City);
            setClasss(data.Class);
            setTestDetails(data.TestHistory);
            setIfLoading(false);
        }
    }


    const checkuser = async () => {
        const user = Cookies.get("user");
        if (user === undefined) {
            navigate("/login");
        }
        else {
            setLoadedData();
        }

        if (localStorage.getItem("timeOut")) {
            Swal.fire({
                title: 'Warning !!',
                text: 'You have been suspected of leaving test in between. Please contact your teacher.',
                icon: 'warning',
                confirmButtonText: 'Ok'
            }).then(() => {
                localStorage.removeItem("timeOut");
                localStorage.removeItem("testId");
                localStorage.removeItem("test");
            })

        }
    }

    useEffect(() => {
        checkuser();
    }, [])

    const ref = useRef(null);
    const Loader = () => {
        useEffect(() => {
            const Animator = lottie.loadAnimation({
                container: ref.current,
                animationData: require('../Animations/GeneralLoading.json'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
            });

            return () => Animator.destroy();
        }, [])

        return (
            <div className='flex justify-center items-center h-screen w-[min(100vw,50rem)] flex-col'>
                <div ref={ref} className='w-[min(100vw,50rem)]'> </div>
                <p>Loading Assets</p>
            </div>
        );

    }

    return (
        <div className='p-[2vw]'>
            <div className='MQSidebar'>
                <SideBarGPT />
                {ifLoading ? (
                    <Loader />
                ) : (
                    <>
                        {(showAnalysis === true)
                            &&
                            <TestAnalysis
                                testAnalysis={testAnalysis}
                                user={user}
                                fathername={fathername}
                                classs={classs}
                                city={city}
                                setShowAnalysis={setShowAnalysis}
                            />}
                        {(showAnalysis === false)
                            &&
                            <PreviousResults
                                testDetails={testDetails}
                                setTestAnalysis={setTestAnalysis}
                                setShowAnalysis={setShowAnalysis}
                                showAnalysis={showAnalysis}
                            />}
                    </>
                )}
            </div>
        </div >
    )
}

export default MyTestAttempts
